var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5122_4635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2C0 1.43269 1.43269 0 3.2 0H13.6L24 10.4V28.8C24 30.5673 22.5673 32 20.8 32H3.2C1.43269 32 0 30.5673 0 28.8V3.2Z",
    fill: "#0062E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.4H24L13.6 0V8C13.6 9.32548 14.6745 10.4 16 10.4Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79997 22H12.4M8.79997 17.2H15.2M8.79997 19.6H15.2M7.05879 14.8H16.9411C17.305 14.8 17.6 15.0686 17.6 15.4V26.2C17.6 26.5314 17.305 26.8 16.9411 26.8H7.05879C6.69493 26.8 6.39996 26.5314 6.39996 26.2V15.4C6.39996 15.0686 6.69493 14.8 7.05879 14.8Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5122_4635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDoc);
export default __webpack_public_path__ + "static/media/file-doc.566d7519c2ae32560ae8792c28d3aca2.svg";
export { ForwardRef as ReactComponent };